import type { BootFeatureFlags, BootState } from './boot-state';

export function applyAdminQueryFlags(
  _params: URLSearchParams,
  parsed: BootFeatureFlags
): BootFeatureFlags {
  return parsed;
}

export function applyAdminQueryIdentity(
  _params: URLSearchParams,
  boot: Partial<BootState>
): Partial<BootState> {
  return boot;
}
